import React, { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";
import TableWithPagination from "./../common/TableWithPagination";
import FormEditarUsuario from "./FormEditarUsuario"; // Nuevo componente de panel

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [marketplaces, setMarketplaces] = useState([]);

  const { get, post, del } = useApi();


  const emptyForm = {
    nombre: "",
    email: "",
    numEmpleado: "",
    rolId: "",
    estatusId: "",
    marketplaces: [],
  };
  const [form, setForm] = useState(emptyForm);

  const [editUsuario, setEditUsuario] = useState(null); // controla si se muestra el panel

  // -------------------------------
  // CARGA USUARIOS
  // -------------------------------
  const obtenerUsuarios = async () => {
    setLoading(true);
    try {
      const data = await get("ListaUsuarios");
      setUsuarios(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerUsuarios();
  }, []);

  // -------------------------------
  // CARGA PERFILES
  // -------------------------------
  useEffect(() => {
    const fetchPerfiles = async () => {
      try {
        const data = await get("ListaRoles");
        setPerfiles(data);
      } catch (e) {
        console.error("Error cargando perfiles:", e);
      }
    };
    fetchPerfiles();
  }, []);

  // -------------------------------
  // NUEVO USUARIO / EDITAR
  // -------------------------------
  const nuevoUsuario = () => {
    setForm(emptyForm);
    setEditUsuario({ id: null }); // Panel abierto
  };

  const handleEdit = async (usuario) => {
    
    const procesos = await get('listaprocesosUser', { urlParams: { id: usuario.id } });
    console.log("Procesos del usuario:", procesos);

    setForm({
      nombre: usuario.nombre,
      email: usuario.email,
      numEmpleado: usuario.numEmpleado,
      rolId: usuario.rolId,
      estatusId: usuario.estatusValor,
      marketplaces:procesos,

    });
    setEditUsuario({ id: usuario.id });
  };

  const cancelarEdicion = () => {
    setEditUsuario(null);
    setForm(emptyForm);
  };

  // -------------------------------
  // GUARDAR USUARIO
  // -------------------------------
  const handleSubmit = async () => {
    const payload = {
      Id: editUsuario?.id || undefined,
      Nombre: form.nombre,
      Email: form.email,
      Perfil: Number(form.rolId),
      NumEmpleado: form.numEmpleado,
      Estatus: Number(form.estatusId),
      Marketplaces: form.marketplaces.map((m) => ({
        MarketplaceId: m.id,
        Activo: m.activo,
      })),
    };

    try {
      setLoading(true);
      await post("updateUsuario", payload);
      cancelarEdicion();
      obtenerUsuarios();
    } catch (err) {
      console.error("Error guardando:", err);
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------
  // BORRAR USUARIO
  // -------------------------------
  const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este usuario?")) return;
    try {
      await del("deleteUser", { urlParams: { id } });
      obtenerUsuarios();
    } catch (e) {
      console.error("Error al eliminar:", e);
    }
  };

  return (
    <div className="lg:col-span-8 col-span-12">
      <div className="flex justify-between items-center flex-wrap mb-6">
        <h6 className="font-bold text-base">Usuarios</h6>

        <button
          onClick={nuevoUsuario}
          className="px-2 py-1 text-sm bg-green-900 text-white rounded hover:bg-green-700"
        >
          + Nuevo
        </button>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="relative overflow-y-visible overflow-x-auto mx-4 pt-3">
            <div className="inline-block min-w-full">
              {loading && <div className="text-center py-4">Cargando...</div>}

              {/* Tabla visible solo si NO estamos editando */}
              {!editUsuario && (
                <TableWithPagination
                  columns={[
                    { header: "#Empleado", accessor: "numEmpleado" },
                    { header: "Nombre", accessor: "nombre" },
                    { header: "Email", accessor: "email" },
                    { header: "Perfil", accessor: "rol" },
                    { header: "Estatus", accessor: "estatus" },
                  ]}
                  data={usuarios.map((u) => ({
                    id: u.id,
                    nombre: u.nombre,
                    email: u.email,
                    rol: u.rol,
                    rolId: u.perfil,
                    numEmpleado: u.numEmpleado,
                    estatusValor: u.estatus,
                    estatus: (
                      <span className="flex items-center gap-2">
                        <span
                          className={`w-3 h-3 rounded-full inline-block ${
                            u.estatus === 1 ? "bg-green-500" : "bg-red-500"
                          }`}
                        />
                        {u.estatus === 1 ? "Activo" : "No activo"}
                      </span>
                    ),
                  }))}
                  showView={false}
                  onEdit={handleEdit}
                  onDelete={(u) => handleDelete(u.id)}
                  searchPlaceholder="Buscar usuario..."
                />
              )}

              {/* Panel de edición */}
              {editUsuario && (
                <FormEditarUsuario
                  usuarioId={editUsuario?.id}
                  post={post}
                  form={form}
                  setForm={setForm}
                  perfiles={perfiles}
                  onSave={handleSubmit}
                  onCancel={cancelarEdicion}
                  loading={loading}
                  marketplaces={form.marketplaces}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usuarios;
